import { render, staticRenderFns } from "./CategoryTabAttributes.vue?vue&type=template&id=1e66e4ec&scoped=true"
import script from "./CategoryTabAttributes.vue?vue&type=script&lang=ts"
export * from "./CategoryTabAttributes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e66e4ec",
  null
  
)

export default component.exports